module.exports = __webpack_public_path__ + "img/14.d5b6124f.jpg";